export default __webpack_public_path__ + "static/data-more-about-img3-ed319a39e6eab3761bf0520eb32b067e.webp";